<template>
  <ul v-for="elem in subscriptionsList" v-bind:key="elem.id">
    <li v-if="elem.disabled == 0">
      <div class="form-check form-switch">
        <input
          @click="isUserSubscribed(elem.id) ? unsubscribe(elem.id) : newSubscription(elem.id)"
          class="form-check-input"
          type="checkbox"
          id="flexSwitchCheckChecked"
          :checked="isUserSubscribed(elem.id)"
        />
        <label class="form-check-label" for="flexSwitchCheckChecked">
          <strong>Newsletter "{{ elem.name }}" per E-Mail erhalten.</strong>
        </label>
      </div>
    </li>
  </ul>
</template>

<script>
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { RepositoryFactory } from '@/api/repositoryFactory';
import { newsletterStore } from '@/store/newsletter-store';
import { ref, computed, onMounted } from 'vue';
import newsletterRepository from '@/api/newsletterRepository';
import { userStore } from '@/store/user-store';

export default {
  name: 'NewsletterSubscriptions',

  components: {},

  setup() {
    //-------------CONSTANTE--------------
    const subscriptionsList = ref(0);
    const userSubscriptionsList = ref(0);

    //computed
    const user = computed(() => {
      return userStore.getState().user;
    });
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });

    //------------FUNCTION----------------
    function fetchNewsletter() {
      newsletterRepository.get().then(nList => {
        subscriptionsList.value = nList;
      });
    }

    function fetchNewsletterSubscriptions() {
      if (isLoggedIn.value && user.value.id) {
        newsletterRepository.getSubscriptionListOfUser(user.value.id).then(sub => {
          userSubscriptionsList.value = sub.subscriptions;
        });
      }
    }
    function unsubscribe(id) {
      newsletterRepository.unsubscribe_user(id).then(response => {
        fetchNewsletterSubscriptions();
      });
    }

    function newSubscription(id) {
      newsletterRepository.subscribe_user(id).then(response => {
        fetchNewsletterSubscriptions();
      });
    }

    // check whether the user is subscribed to the newsletter
    function isUserSubscribed(newsletterId) {
      if (userSubscriptionsList.value == 0) {
        return false;
      }
      return userSubscriptionsList.value.filter(e => e.id == newsletterId).length > 0;
    }

    onMounted(() => {
      fetchNewsletter();
      fetchNewsletterSubscriptions();
    });

    return {
      //-------------CONSTANTE--------------
      userSubscriptionsList,
      subscriptionsList,

      //------------FUNCTION----------------
      newSubscription,
      unsubscribe,
      isUserSubscribed,
    };
  },
  componenents: {
    WdwDynbox,
  },
};
</script>

<style scoped>
.wdw-widgets ul {
  list-style-type: none;
  padding-left: 0px;
}
input[type='checkbox']:after {
  display: none;
}
</style>
